export default __webpack_public_path__ + "4a6844c4ab27dc7f29ef8f00dec55fca.jpg";